<div [formGroup]="service.formGroup">
  <!-- SCALE MODE: Material slider (no icon, no gradient) -->
  <ng-container *ngIf="useScale; else nonScale">
    <div
      [formGroup]="service.formGroup"
      [ngClass]="{
        'nps-slider-wrap': true,
        'is-unanswered': !hasValue,
        'has-gradient': useGradient,
        'has-scale': service.themeService.getThemeColor(
          service.themeService.ThemeItemEnum.scaleTrackColour
        ),
        'has-scale-selected': service.themeService.getThemeColor(
          service.themeService.ThemeItemEnum.scaleTrackSelectedColour
        )
      }"
      [ngStyle]="{
        '--scale-gradient': useGradient
          ? scaleGradient
          : service.themeService.getThemeColor(service.themeService.ThemeItemEnum.scaleTrackColour),
        '--scale-selected-track-color': service.themeService.getThemeColor(
          service.themeService.ThemeItemEnum.scaleTrackSelectedColour
        )
      }"
    >
      <mat-slider
        class="nps-slider"
        [min]="sliderMin"
        [max]="sliderMax"
        step="1"
        discrete
        showTickMarks
        [displayWith]="descriptionFor"
      >
        <input
          matSliderThumb
          [value]="scaleValue"
          (valueChange)="onScaleValueChange($event)"
          (dragEnd)="confirmScaleValue($event.value)"
          (keyup)="confirmScaleFromKeyboard($event)"
        />
      </mat-slider>
      <div class="nps-slider-labels">
        <span
          *ngFor="let range of scaleRanges"
          class="nps-slider-label"
          [style.left.%]="labelPosition(range.value)"
          [matTooltip]="range.description"
        >
          {{ range.value }}
        </span>
      </div>
      <div class="nps-segmented-labels">
        <span class="nps-segmented-label nps-segmented-label--start">{{ firstLabel }}</span>
        <span class="nps-segmented-label nps-segmented-label--end">{{ lastLabel }}</span>
      </div>
    </div>
  </ng-container>

  <!-- DEFAULT MODE: original segmented button bar -->
  <ng-template #nonScale>
    <div class="nps-segmented-wrap">
      <div class="nps-segmented">
        <div
          class="nps-cell"
          *ngFor="let range of scaleRanges"
          (click)="selectOption(range.value)"
          [class.selected]="control.value === range.value"
          [style.background-color]="control.value === range.value ? null : range.NPSColor"
        >
          <input
            #input
            type="radio"
            [formControlName]="question.getName()"
            [value]="range.value"
            class="nps-cell__input"
          />
          <span class="nps-cell__value">{{ range.value }}</span>
        </div>
      </div>
      <div class="nps-segmented-labels">
        <span class="nps-segmented-label nps-segmented-label--start">{{ firstLabel }}</span>
        <span class="nps-segmented-label nps-segmented-label--end">{{ lastLabel }}</span>
      </div>
    </div>
  </ng-template>
</div>
